// theirs
import styled from 'styled-components'
// ours
import { IntroOurStoryProps } from '.'
import { respondToRetina, respondToWidth } from '../../../mixins/respondTo'
import { breakpoints, color, typography } from '../../../styles'

export const introOurStoryBaseClass = 'intro-our-story'

export const StyledIntroOurStory = styled.div<IntroOurStoryProps>`
    &.${introOurStoryBaseClass} {
        background-color: ${(props) => props.content.contentBackgroundColor};
        padding: 0;
        margin: 0;
        position: relative;
        height: 100%;
        width: 100%;
        display: table;
        z-index: 2;

        .content-outer {
            display: table-cell;
            vertical-align: middle;
            padding-top: 5%;
            position: relative;
            z-index: 20;
        }

        .content-inner {
            margin: 0 auto;
            text-align: center;
        }

        .title-wrapper {
            display: block;
        }

        h2 {
            font-family: ${typography.type.secondary};
            font-weight: ${typography.weight.bold};
            font-style: ${typography.style.normal};
            font-size: ${typography.size.code};
            color: ${(props) => props.content.contentTitleColor};
            text-transform: uppercase;
            max-width: 785px;
            text-align: center;
            margin: -7rem auto 0 auto;
            padding: 0;

            letter-spacing: normal;
            line-height: normal;

            ${respondToWidth.xl`
            font-size: ${typography.size.code2};
        `}

            ${respondToRetina.xxxxl`
            font-size: ${typography.size.code3};
        `}
        }

        .text-wrapper {
            margin-top: 2rem;
            margin-bottom: 2.5rem;
            padding: 0 1rem;

            p {
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.64;
                letter-spacing: 0.88px;
                text-align: ${(props) =>
                    props.content.contentTextInnerAlignment?.toLocaleLowerCase()};
                color: ${(props) => props.content.contentTextColor};
                padding: 0 2rem;

                font-size: ${typography.size.s2};
                @media (min-width: ${breakpoints.xs}) {
                    font-size: ${typography.size.s3};
                    padding: 0 4rem;
                }

                @media (min-width: ${breakpoints.lg}) {
                    padding: 0;
                }
            }
        }

        .help-text-wrapper {
            width: 100%;
            text-align: center;
            display: block;
            position: absolute;
            bottom: 0;
            z-index: 30;
            left: 0;

            @media (min-width: ${breakpoints.md}) {
            }

            .help-text {
                font-size: ${typography.size.m2};
                color: ${color.lightest};
                margin-bottom: 1rem;

                @media (min-width: ${breakpoints.md}) {
                    font-size: ${typography.size.m1};
                }
            }

            .vertical-line {
                border-left: 2px solid ${color.lightest};
                height: 2rem;
                margin: 0 auto;
                width: 2px;

                @media (min-width: ${breakpoints.lg}) {
                    height: 8.5rem;
                }

                @media (min-width: ${breakpoints.xl}) {
                    height: 9rem;
                }

                @media (min-width: ${breakpoints.xxl}) {
                    height: 10.5rem;
                }
            }
        }

        .video-wrapper {
            position: absolute;
            height: 100%;
            width: 100%;
            top: 0;
            left: 0;
            z-index: 10;
            display: grid;

            video {
                justify-self: center;
                height: 100%;
                width: 100%;
            }
        }
    }
`
